/* eslint-disable no-console */

// eslint-disable-next-line import/named
import { _fork } from '../creativeHub/listenerMiddleware';
import * as gereralActions from './actions';
import { deriveAbortController } from './utils/deriveAbortController';
import { ListenerApiSafe } from './listenerMiddlewareAddons';
import { Interrupt, TSagaReturn } from './scenarioFactory';
/* tslint:disable: no-console */
const group = (label: string) => {
  if (process.env.NODE_ENV === 'development') {
    console.group(label);
  }
};
const groupEnd = () => {
  if (process.env.NODE_ENV === 'development') {
    console.groupEnd();
  }
};

export function scenarioFactoryAsync<TStoreShape, TArgs extends any[], TReturn = any>(
  scenario: (lapi: ListenerApiSafe<TStoreShape>, ...args: TArgs) => Promise<TReturn>,
  cancelPromise:
    | ((lapi: ListenerApiSafe<TStoreShape>, ...args: TArgs) => Promise<void>)
    | null
    | undefined,
  cleanup:
    | ((lapi: ListenerApiSafe<TStoreShape>, ...args: TArgs) => Promise<void>)
    | ((lapi: ListenerApiSafe<TStoreShape>, ...args: TArgs) => void)
    | null
    | undefined,
  key: string,
) {
  async function scenarioInner(
    lapi: ListenerApiSafe<TStoreShape>,
    ...args: TArgs
  ): Promise<TSagaReturn<TReturn>> {
    if (key) {
      group(key);
      lapi.dispatch(gereralActions.scenarioBegin({ key }));
    }

    const abortController = deriveAbortController(lapi.signal);

    const abortWatchTask = _fork(lapi, async (_lapi) => {
      if (cancelPromise) {
        // try {
        await cancelPromise(_lapi, ...args);
        abortController.abort();
        // } catch (x) {
        // if (!(x instanceof TaskAbortError)) throw x;
        // }
      }
    });

    const conclude = async () => {
      abortWatchTask.cancel();
      if (cleanup) {
        await cleanup(lapi, ...args);
      }
      if (key) {
        lapi.dispatch(gereralActions.scenarioEnd({ key }));
        groupEnd();
      }
    };
    try {
      const result = await scenario({ ...lapi, signal: abortController.signal }, ...args);
      if (abortController.signal.aborted) {
        throw Interrupt.Exception('request');
      }
      await conclude();
      return { success: true, args, data: result };
    } catch (reason) {
      await conclude();
      return { success: false, args, reason: reason as Interrupt };
    }
  }
  return scenarioInner;
}
